module.exports = __webpack_public_path__ + "img/onepay_logo.d992dfbf.png";